import React from 'react';
import { PageSection, IconCircleExclamation } from 'adc-ui-components';

const ReturnsDowntime = () => (
  <PageSection className="ui-grey page-section--banner">
    <IconCircleExclamation className="mb12 svg-icon--42" />

    <div className="mb24">
      <h1 className="heading2 mb6">Down for scheduled maintenance</h1>
      <p className="body2">
        Your equipment return information is unavailable at this time. Please check back later.
      </p>
    </div>

    <a className="button button--primary" href="/">Back to My Account</a>
  </PageSection>
);

export default ReturnsDowntime;
